@if (item().link) {
  <a
    href="{{ item().link }}"
    target="_blank"
    role="menuitem"
    [attr.aria-label]="item().title + ', ' + item().description"
  >
    <ng-container *ngTemplateOutlet="flyOutItemTemplate" />
  </a>
}
@if (item().isElevio) {
  <a
    href="https://ftr.elevio.help/en"
    target="_blank"
    [class]="item().elevioClass || 'elevio__help'"
    role="menuitem"
    [attr.aria-label]="item().title + ', ' + item().description"
    (keydown.enter)="elevioElementClick()"
  >
    <ng-container *ngTemplateOutlet="flyOutItemTemplate" />
  </a>
}

<ng-template #flyOutItemTemplate>
  <div class="help-sub-menu-flyout-item">
    <div class="help-sub-menu-flyout-item__badge">
      <div class="help-sub-menu-flyout-item__badge-circle" [style.background]="item().badgeColor">
        <ftr-badge [icon]="item().icon" [color]="item().iconColor" />
      </div>
    </div>
    <div class="help-sub-menu-flyout-item__detail">
      <div class="help-sub-menu-flyout-item__title">{{ item().title }}</div>
      <div class="help-sub-menu-flyout-item__description">{{ item().description }}</div>
    </div>
  </div>
</ng-template>
